import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { googleCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/auth");
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    googleCallback(sessionId)
      .then(() => {
        toast.success("Signed in with Google.");
        // Strip the hash before navigating
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/profile");
      })
      .catch((err) => {
        toast.error(formatApiError(err));
        navigate("/auth");
      });
  }, [googleCallback, navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#050505] text-zinc-400">
      <div className="text-center">
        <div className="font-display text-2xl text-white">Authenticating...</div>
        <p className="mt-2 text-xs uppercase tracking-widest text-[#D4AF37]">Forging your session</p>
      </div>
    </div>
  );
}
